/**
 * Собирает FormData из простого объекта, массивов, вложенных объектов и файлов.
 *
 * @param {Record<string, any>} data
 * @returns {FormData}
 */
export function prepareFormData(data) {
  const form = new FormData()

  const prepareArray = (currentData, itemKey) => {
    for (const [key, valueRaw] of Object.entries(currentData)) {
      let value = valueRaw

      if (value instanceof File) {
        form.append(itemKey ?? key, value, value.name)
      } else if (Array.isArray(value)) {
        prepareArray(value, `${key}[]`)
      } else {
        if (typeof value === 'object' && value !== null) {
          value = JSON.stringify(value)
        }

        form.append(itemKey ?? key, value)
      }
    }
  }

  prepareArray(data)

  return form
}
